interface VersionChipProps {
  versionNumber: number | null;
}

export function VersionChip({ versionNumber }: VersionChipProps) {
  if (versionNumber === null) return null;
  return (
    <span className="rounded-full bg-surface-strong px-2 py-0.5 text-xs font-medium text-text-secondary">
      v{versionNumber}
    </span>
  );
}
